import { Sparkles, BookOpen, ScanText, Mic, Volume2 } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { Summarizer } from './Summarizer';
import { ReadabilityChecker } from './ReadabilityChecker';
import { Ocr } from './Ocr';
import { SpeechToText } from './SpeechToText';
import { TextToSpeech } from './TextToSpeech';

export const writingTools: Tool[] = [
  {
    id: 'ocr',
    name: 'OCR — image to text',
    category: 'writing',
    description: 'Extract text from photos, scans, and screenshots.',
    keywords: ['ocr', 'image', 'text', 'recognition', 'scan', 'tesseract'],
    icon: ScanText,
    component: Ocr,
    featured: true,
    accepts: 'image',
    inBrowser: true,
  },
  {
    id: 'speech-to-text',
    name: 'Speech to text',
    category: 'writing',
    description: 'Live dictation in 12 languages using the Web Speech API.',
    keywords: ['speech', 'voice', 'dictation', 'transcribe', 'recognition'],
    icon: Mic,
    component: SpeechToText,
    featured: true,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'text-to-speech',
    name: 'Text to speech',
    category: 'writing',
    description: 'Read text aloud using the browser’s built-in voices.',
    keywords: ['text to speech', 'tts', 'voice', 'read aloud', 'speak'],
    icon: Volume2,
    component: TextToSpeech,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'summarizer',
    name: 'Summarizer',
    category: 'writing',
    description: 'Extractive summary using sentence frequency analysis.',
    keywords: ['summarize', 'tldr', 'tl;dr', 'shorten', 'condense'],
    icon: Sparkles,
    component: Summarizer,
    accepts: 'text',
    inBrowser: true,
  },
  {
    id: 'readability',
    name: 'Readability checker',
    category: 'writing',
    description: 'Flesch reading ease and Flesch-Kincaid grade level.',
    keywords: ['readability', 'flesch', 'kincaid', 'reading', 'grade'],
    icon: BookOpen,
    component: ReadabilityChecker,
    accepts: 'text',
    inBrowser: true,
  },
];
